import { render, staticRenderFns } from "./LayoutGridCategoryPicker.vue?vue&type=template&id=304f63cc&scoped=true&"
import script from "./LayoutGridCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./LayoutGridCategoryPicker.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGridCategoryPicker.vue?vue&type=style&index=0&id=304f63cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f63cc",
  null
  
)

export default component.exports